import { isEmpty } from "lodash";

import {
  getUserProfilePhotoService,
  getUserProfileService,
} from "../../../services/userServices";
import { defaultPicture } from "./../../../utils/index";

export const setUserInfoAction = (userInfo) => {
  return async (dispatch) => {
    if (userInfo) {
      await dispatch({ type: "SET_USER_INFO", payload: userInfo });
    } else {
      try {
        const { status, data } = await getUserProfileService();
        if (status === 200) {
          if (isEmpty(data.avatar)) {
            await dispatch({
              type: "SET_USER_INFO",
              payload: { ...data, avatar: defaultPicture },
            });
          } else {
            try {
              const { status, data: photoData } =
                await getUserProfilePhotoService({
                  file_name: data?.avatar[data.avatar?.length - 1]?.name,
                });
              if (status === 200) {
                await dispatch({
                  type: "SET_USER_INFO",
                  payload: {
                    ...data,
                    avatar: isEmpty(photoData?.encoded_string)
                      ? defaultPicture
                      : `data:image/jpeg;base64,${photoData?.encoded_string}`,
                  },
                });
              }
            } catch ({ response }) {
              await dispatch({
                type: "SET_USER_INFO",
                payload: { ...data, avatar: defaultPicture },
              });
              console.log("Karbama Photo");
            }
          }
        }
      } catch ({ response }) {
        console.log("Karbama Info");
      }
    }
  };
};

export const clearUserInfoAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_USER_INFO", payload: {} });
  };
};
